module.exports = __webpack_public_path__ + "da6860ec48c43b1bf739588114d64d2d.ttf";